import { uwillValidatorMixin } from "../form/uwillValidatorMixin.js";

const MAX_FOCUS_AREAS = 3;

export const uwillProfileCategoryMixin = {
  mixins: [uwillValidatorMixin],
  props: {
    mode: {
      default: "create",
      type: String
    },
    isProvider: {
      default: false,
      type: Boolean
    },
    isInstructor: {
      default: false,
      type: Boolean
    },
    isContractor: {
      default: false,
      type: Boolean
    },
    isBasicNeedsSpecialist: {
      default: false,
      type: Boolean
    },
    adaZoom: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    threePerRowColumns: function() {
      return this.mode == "create" || this.adaZoom == true ? 12 : 4;
    },
    twoPerRowColumns: function() {
      return this.mode == "create" || this.adaZoom == true ? 12 : 6;
    }
  },
  methods: {
    // Grey out the remaining focus area choices once the limit is reached, so
    // the cap is visible in the menu instead of silently truncating the
    // selection. Already-selected items stay enabled so they can be deselected.
    // Providers have no focus area limit.
    focusAreaItemProps: function(item) {
      if (this.isProvider) return {};

      const atLimit = this.focusAreas?.length >= MAX_FOCUS_AREAS;
      return { disabled: atLimit && !this.focusAreas.includes(item) };
    }
  }
};
